import { localInitData } from './data/local-init-data';
import { GameBackend } from '@src/backend/types';
import { BonusGame, GameInitData, PlayResponse } from '../types';
import { IS_DEV } from '../constants';
import { getLocalPlinkoPlayData } from './data/local-play-plinko.data';
import { getLocalBallSpinPlayData } from './data/local-play-ball-spin.data';
import { getLocalFortuneWheelsPlayData } from './data/local-play-fortune-wheels.data';
import { getLocalCashReelsPlayData } from './data/local-play-cash-reels.data';
import { localInitPlinkoData } from './data/local-init-plinko.data';
import { localInitBallSpinData } from './data/local-init-ball-spin.data';
import { localInitCashReelsData } from './data/local-init-cash-reels.data';
import { localInitFortuneWheelsData } from './data/local-init-fortune-wheels.data';
import { getLocalNoBonusPlayData } from './data/local-play-no-bonus.data';
import { localBonusCashReelsData } from './data/local-bonus-cash-reels.data';
import { localBonusPlinkoData } from './data/local-bonus-plinko.data';
import { localBonusFortuneWheelData } from './data/local-bonus-fortune-wheel.data';
import { localBonusBallSpinData } from './data/local-bonus-ball-spin.data';

const bonusDataByType: Record<BonusGame, PlayResponse> = {
    CASH_REELS: localBonusCashReelsData,
    PLINKO: localBonusPlinkoData,
    FORTUNE_WHEEL: localBonusFortuneWheelData,
    BALL_SPIN: localBonusBallSpinData
};
const getBonusDataByGameType = function () {
    const game = getInitGame() || getActiveGame();
    return bonusDataByType[game];
};

const dataByType: Record<BonusGame | 'NO_BONUS', () => PlayResponse> = {
    PLINKO: getLocalPlinkoPlayData,
    BALL_SPIN: getLocalBallSpinPlayData,
    CASH_REELS: getLocalCashReelsPlayData,
    FORTUNE_WHEEL: getLocalFortuneWheelsPlayData,
    NO_BONUS: getLocalNoBonusPlayData
};

const initDataByType: Record<BonusGame, GameInitData> = {
    PLINKO: localInitPlinkoData,
    BALL_SPIN: localInitBallSpinData,
    CASH_REELS: localInitCashReelsData,
    FORTUNE_WHEEL: localInitFortuneWheelsData
};

const getDataByGameType = () => dataByType[getActiveGame()]();
const getInitData = () => initDataByType[getInitGame()] || localInitData;

const getGames = (): BonusGame[] => ['PLINKO', 'BALL_SPIN', 'FORTUNE_WHEEL', 'CASH_REELS'];
// const getRandomGame = (): BonusGame => getRandomArrayElement(getGames());

function updateURL(gameId: BonusGame) {
    const newurl =
        window.location.protocol + '//' + window.location.host + window.location.pathname + '#active=' + gameId;
    window.history.pushState({ path: newurl }, '', newurl);
}

function getActiveGame() {
    return new URLSearchParams(window.location.hash.substring(1)).get('active') || 'NO_BONUS';
}

function getInitGame() {
    return new URLSearchParams(window.location.hash.substring(1)).get('init') || null;
}

if (IS_DEV) {
    const activeGame = getActiveGame();
    if (activeGame && getGames().indexOf(activeGame as BonusGame) >= 0) {
        updateURL(activeGame as BonusGame);
    }
}

const localBackend: GameBackend = {
    init: async () => {
        await new Promise(r => setTimeout(r, 50)); //TODO simulate random latency
        return getInitData();
    },
    play: async () => {
        await new Promise(r => setTimeout(r, 50)); //TODO simulate random latency
        return getDataByGameType();
    },
    playBonus: async (/*gameType: BonusGame, choice: number = -1*/) => {
        await new Promise(r => setTimeout(r, 50)); //TODO simulate random latency
        return getBonusDataByGameType();
    }
};

export default localBackend;
